<template>
  <div>
    <div style="position: absolute; top: 10; left; 10" id="backButton">
      <font-awesome-icon @click="goRouter('/sportsengine')" class="menuIcon" icon="arrow-left" />
    </div>
    <img src="/se_logo_full.png" style="width: 300px; max-width: 90%" />
    <h1 class="title is-3">Export Schedules</h1>
    <div v-if="currentSeason">
      <div v-if="!currentSeason.schedules.length">
        <br />
        <p>No schedules to export. Create one first!</p>
        <br />
        <Button class="p-button-lg" label="Create Schedule" @click="goRouter('/schedules/new')" />
      </div>

      <div
        v-for="schedule in currentSeasonSchedules"
        :key="schedule.id"
        class="p-col-12 rounded paddedCol whiteBg p-my-3 cursorpointer"
        style="border: 1px solid lightgrey"
      >
        <div class="p-grid p-text-left">
          <div class="p-col-12">
            <h3 class="title is-3">
              {{ schedule.name }}
              <div class="floatRight">
                <Button v-if="seConnected" class="floatRight" label="EXPORT" @click.stop="exportSchedule(schedule)" />
                <div v-else style="font-size: 16px; text-align: center">
                  <div style="color: red; text-align: center; margin-bottom: 5px;">Not Available</div>
                  <div style="font-size: 12px; font-weight: normal">
                    All teams must exist in SportsEngine before exporting
                  </div>
                </div>
              </div>
            </h3>
          </div>
          <div class="p-col-12">
            <strong> Divisions </strong>
            <div>
              <span v-for="(x, i) in schedule.divisions" :key="x.id">
                <router-link :to="`/divisions/${x.id}`">{{ x.name }}</router-link>
                <span v-if="i < schedule.divisions.length - 1">,</span>
              </span>
            </div>
          </div>
          <div class="p-col-12">
            <strong> Results </strong>
            <div>{{ schedule.scheduled }} scheduled, {{ schedule.unscheduled }} unscheduled</div>
          </div>
          <div class="p-col-12">
            <strong> Created </strong>
            <div>
              {{ new Date(schedule.created_at).toLocaleString() }}
            </div>
          </div>
          <div class="p-col-12" v-if="schedule.last_export_to_se">
            <strong style="color: red"> Last Export to SportsEngine </strong>
            <div>
              {{ new Date(schedule.last_export_to_se).toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  // ddd
  data() {
    return {
      status: 0,
    };
  },
  computed: {
    currentSeasonSchedules() {
      return this.currentSeason.schedules.filter(s => s.can_export_se);
    },
    header() {
      if (this.status == 1) {
        return "Export Schedules";
      } else if (this.status == 2) {
        return "Delete Games";
      } else {
        return "Account Connected!";
      }
    },
  },
  methods: {
    clearAll() {
      this.trackEvent("Started SportsEngine Clear", {});
      var x = window.confirm(
        "You about to clear ALL Diamond Scheduler created games from your SportsEngine account. Press OK to continue or cancel to not proceed",
      );
      if (x) {
        this.trackEvent("Confirmed SportsEngine Clear", {});
        api
          .deleteAllSportsEngine(this.currentSeason.se_id)
          .then(response => {
            console.log(response);
            this.goRouter(`/activity/${response.data.activity.id}`);
          })
          .catch(e => {
            this.makeToast("error", "Could clear games: " + e);
          });
      } else {
        this.trackEvent("Cancelled SportsEngine Clear", {});
        this.makeToast("info", "Action Cancelled - No games deleted");
      }
    },
  },
  created() {},
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
.seButton {
  width: 400px;
  max-width: 95%;
  margin: 0 auto;
}
</style>
